export default __webpack_public_path__ + "static/media/filterDivider.fa9d55e2.svg";